export default {
  en: { all_day: 'All day' },
};
